var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',_vm._l((_vm.renderedServices),function(service){return _c('v-col',{key:service.name,attrs:{"cols":_vm.cols,"sm":_vm.sm,"md":_vm.md,"lg":_vm.lg}},[_c('service-card',{attrs:{"name":service.name,"image":service.image,"title":service.title,"subtitle":service.subtitle}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }